<template>
        <v-container>
            <v-row class="contentRow" justify="center">
                <v-col cols="12">
                    <h1 class="mb-2">Orixe Trace</h1>
                </v-col>
            </v-row>
            <v-row class="contentRow" align="center">
                <v-col cols="12" style="align-self: baseline" >
                        <v-menu offset-y  >
                            <template v-slot:activator="{ on, attrs }">
                                <v-chip
                                        label
                                        color="primary"
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                >
                                    <span>Last <b>{{rejectedReceivedTransactionOptions.selectedDays}}</b> days</span>
                                </v-chip>
                            </template>
                            <v-list>
                                <v-list-item-group @change="dayChange">
                                    <v-list-item
                                            v-for="(item, index) in items"
                                            :key="index"
                                            :value="item"
                                    >
                                        <v-list-item-title>{{ item }}</v-list-item-title>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </v-menu><br />
                </v-col>
                <v-col cols="6">
                    <v-simple-table style="background: #e8e8e8" >
                        <template v-slot:default>
                            <tbody>
                            <tr>
                                <td>
                                    Received transactions last
                                    <strong>
                                        {{receivedTransactionOptions.selectedDays}}
                                    </strong>
                                    days
                                </td>
                                <td>{{receivedTransactionOptions.value}}</td>
                            </tr>
                            <tr>
                                <td>
                                    Sent transactions last
                                    <strong>
                                        {{sentTransactionOptions.selectedDays}}
                                    </strong>
                                    days
                                </td>
                                <td>{{sentTransactionOptions.value}}</td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
                <v-col cols="6">
                    <v-simple-table style="background: #f2d0d0">
                    <template v-slot:default>
                        <tbody>
                        <tr>
                            <td>
                               Rejected Received transactions last
                                <strong>
                                    {{rejectedReceivedTransactionOptions.selectedDays}}
                                </strong>
                            </td>
                            <td>{{rejectedReceivedTransactionOptions.value}}</td>
                        </tr>
                        <tr>
                            <td>
                                Rejected Sent transactions last
                                <strong>
                                    {{rejectedSentTransactionOptions.selectedDays}}
                                </strong>
                            </td>
                            <td>{{rejectedSentTransactionOptions.value}}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                </v-col>
            </v-row>
            <v-row class="contentRow" align="center">
                <v-col cols="12">
                    <h3 class="center">Orixe Trace Transactions {{ new Date() | moment("YYYY") }}</h3>
                            <LineChart/>
                </v-col>
                <v-col cols="6" v-if="blockOptions.data.length>0">
                    <v-card color="primary">
                        <v-card-title class="text-center justify-left py-6">
                            <h3 class="white--text">Most Recent Blocks</h3>
                        </v-card-title>

                        <v-data-table
                                theme--
                                light
                                :headers="headers"
                                :items="blockOptions.data"
                                :items-per-page="blockOptions.limit"
                                :options.sync="blockOptions.options"
                                class="light table mx-4 assessed-table data-table"
								:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
                        >
                            <template v-slot:item.Index="{ item }">
                                <a :href="'http://nodes.orixe.tech/blocks/' + item.Index" target="_blank">{{item.Index}}</a>
                            </template>
                            <template v-slot:item.Timestamp="{ item }">
                                {{item.Timestamp}}
                            </template>
                        </v-data-table>
                    <br/>
                    </v-card>
                </v-col>
            </v-row>
            
        </v-container>
</template>


<script>
import LineChart from "../../components/trace/LineChart"
import BlockAPI from "../../api/trace/block"
import TransactionAPI from "../../api/trace/transaction"
import LoadingState from "../../consts/LoadingState"
import TransactionStatus from "../../consts/TransactionStatus"
export default {
	name: "DashboardView",
	components:{
		LineChart
	},
	data() {
		return {
			days:30,
			receivedTransactionOptions:{
				selectedDays:30,
				value:null,
			},
			sentTransactionOptions:{
				selectedDays:30,
				value:null,
			},
			rejectedReceivedTransactionOptions:{
				selectedDays:30,
				value:null,
			},
			rejectedSentTransactionOptions:{
				selectedDays:30,
				value:null,
			},
			blockOptions:{
				data:[],
				loading:true,
				limit:5,
			},
			headers: [
				{
					text: "Block Index",
					align: "start",
					sortable: false,
					value: "Index",
					class: "secondary--text"
				},
				{
					text: "Timestamp",
					value: "Timestamp",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Size",
					value: "Size",
					sortable: false,
					class: "secondary--text"
				},
			],
			items: [30,60,90,180]
		}
	},
	mounted() {
		//Un comment after CORS issue
		//this.getRecentBlocks()
		this.receivedTransactionChange(this.receivedTransactionOptions.selectedDays)
		this.sentTransactionChange(this.sentTransactionOptions.selectedDays)
		this.rejectedReceivedTransactionChange(this.rejectedReceivedTransactionOptions.selectedDays)
		this.rejectedSentTransactionChange(this.rejectedSentTransactionOptions.selectedDays)
	},
	methods: {
		getRecentBlocks(){
			BlockAPI.getRecentBlocks()
				.then(data => {
					this.blockOptions.data=data
					this.blockOptions.loading=false
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		dayChange(dayCount){
			this.receivedTransactionChange(dayCount)
			this.sentTransactionChange(dayCount)
			this.rejectedSentTransactionChange(dayCount)
			this.rejectedReceivedTransactionChange(dayCount)
		},
		async receivedTransactionChange(dayCount){
			if(dayCount){
				this.receivedTransactionOptions.selectedDays=dayCount
				let params = {
					role:2,
					startDate: new Date(new Date().setDate(new Date().getDate() - dayCount)).getTime() ,
					endDate : new Date().getTime(),
					countOnly: true
				}
				let count = await TransactionAPI.getTransactionWithParams(params)
				this.receivedTransactionOptions.value=count
			}
		},
		async sentTransactionChange(dayCount){
			if(dayCount){
				this.sentTransactionOptions.selectedDays=dayCount
				let params = {
					role:1,
					startDate: new Date(new Date().setDate(new Date().getDate() - dayCount)).getTime() ,
					endDate : new Date().getTime(),
					countOnly: true
				}
				let count = await TransactionAPI.getTransactionWithParams(params)
				this.sentTransactionOptions.value = count
			}
		},
		async rejectedReceivedTransactionChange(dayCount){
			if(dayCount){
				this.rejectedReceivedTransactionOptions.selectedDays=dayCount
				let params = {
					role:2,
					status:TransactionStatus.REJECTED,
					startDate: new Date(new Date().setDate(new Date().getDate() - dayCount)).getTime() ,
					endDate : new Date().getTime(),
					countOnly: true
				}
				let count = await TransactionAPI.getTransactionWithParams(params)
				this.rejectedReceivedTransactionOptions.value=count
			}
		},
		async rejectedSentTransactionChange(dayCount){
			if(dayCount){
				this.rejectedSentTransactionOptions.selectedDays=dayCount
				let params = {
					role:1,
					status:TransactionStatus.REJECTED,
					startDate: new Date(new Date().setDate(new Date().getDate() - dayCount)).getTime() ,
					endDate : new Date().getTime(),
					countOnly: true
				}
				let count = await TransactionAPI.getTransactionWithParams(params)
				this.rejectedSentTransactionOptions.value = count
			}
		},

	}
}
</script>